import { Draw, TeamArmy } from '@Models';
import { buildDrawState, DrawState } from '@Stores/index';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: DrawState = buildDrawState({
  entity: null,
}) satisfies DrawState as DrawState;

const opponentDrawSlice = createSlice({
  name: 'opponent-draw',
  initialState,
  reducers: {
    setError(state: DrawState, action: PayloadAction<string>) {
      state.errorMessage = action.payload;
      state.hasError = true;
    },
    setLoading(state: DrawState, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setDraw(state: DrawState, action: PayloadAction<Draw>) {
      state.entity = action.payload;
      state.isLoading = false;
      state.hasError = false;
      state.errorMessage = null;
    },
    // case Actions.Tool.Pairing.Draw.CLOSE_SUCCESS:
    // case Actions.Tool.Pairing.OpponentDraw.RESET:
    closeOrReset(state: DrawState) {
      state.entity = null;
    },
    // case Actions.Tool.Pairing.OpponentDraw.SELECT_ARMY_PROPOSITION_ONE:
    selectPropositionOne(state: DrawState, action: PayloadAction<TeamArmy>) {
      state.entity!.propositionTeamArmyOneId = action.payload.id;
      state.entity!.propositionTeamArmyOne = action.payload;
      state.entity!.propositionTeamArmyConfirmed = false;
    },
    // case Actions.Tool.Pairing.OpponentDraw.SELECT_ARMY_PROPOSITION_TWO:
    selectPropositionTwo(state: DrawState, action: PayloadAction<TeamArmy>) {
      state.entity!.propositionTeamArmyTwoId = action.payload.id;
      state.entity!.propositionTeamArmyTwo = action.payload;
      state.entity!.propositionTeamArmyConfirmed = false;
    },
    // case Actions.Tool.Pairing.OpponentDraw.UNSELECT_PROPOSITION:
    unselectProposition(state: DrawState, action: PayloadAction<string>) {
      if (state.entity!.propositionTeamArmyOneId === action.payload) {
        state.entity!.propositionTeamArmyOneId = null;
        state.entity!.propositionTeamArmyOne = null;
        state.entity!.propositionTeamArmyConfirmed = false;
      } else {
        state.entity!.propositionTeamArmyTwoId = null;
        state.entity!.propositionTeamArmyTwo = null;
        state.entity!.propositionTeamArmyConfirmed = false;
      }
    },
    // case Actions.Tool.Pairing.OpponentDraw.POOL_UPDATE_SUCCESS:
    poolUpdateSuccess(state: DrawState, action: PayloadAction<Draw>) {
      if (
        (state.entity?.propositionTeamArmyOneId ||
          state.entity?.propositionTeamArmyTwoId) &&
        !action.payload.propositionTeamArmyConfirmed
      ) {
        return;
      }

      state.entity = action.payload;
    },
  },
});

export default opponentDrawSlice;
